module.exports = __webpack_public_path__ + "static/media/partners_OnuMulheres.2bc89025.png";